import Bounce from "bounce.js";

export default {
  layout: "topCenter",
  theme: "relax",
  animation: {
    open: function(promise) {
      let n = this;
      new Bounce()
        .translate({
          from: { x: 0, y: -100 },
          to: { x: 0, y: 0 },
          easing: "bounce",
          duration: 1000,
          bounces: 2,
          stiffness: 3
        })
        .scale({
          from: { x: 1, y: 1.2 },
          to: { x: 1, y: 1 },
          easing: "bounce",
          duration: 1000,
          delay: 100,
          bounces: 1,
          stiffness: 1
        })
        .scale({
          from: { x: 1.2, y: 1 },
          to: { x: 1, y: 1 },
          easing: "bounce",
          duration: 1000,
          delay: 100,
          bounces: 3,
          stiffness: 1
        })
        .applyTo(n.barDom, {
          onComplete: function() {
            promise(function(resolve) {
              resolve();
            });
          }
        });
    },
    close: function(promise) {
      var n = this;
      new Bounce()
        .translate({
          from: { x: 0, y: 0 },
          to: { x: 0, y: -150 },
          easing: "bounce",
          duration: 500,
          bounces: 4,
          stiffness: 1
        })
        .applyTo(n.barDom, {
          onComplete: function() {
            promise(function(resolve) {
              resolve();
            });
          }
        });
    }
  }
};
